<template>
  <!--左侧导航-->
  <aside :class="{ showSidebar: !collapsed }">
    <!--导航菜单-->
    <el-menu :default-active="$route.path" router :collapse="collapsed" ref="leftNavigation">
      <template v-for="(issue) in $router.options.routes">
        <!-- 注意：这里就是leftNavState状态作用之处，当该值与router的根路由的name相等时加载相应菜单组 -->
        <template v-if="issue.name === $store.state.leftNavState">
          <template v-for="(item, index) in issue.children">
            <el-submenu v-if="!item.leaf" :index="index + ''" v-show="item.meta.menuShow" :key="index">
              <template slot="title">
                <!-- <i :class="item.iconCls"></i> -->
                <span slot="title">{{ item.name }}</span></template>
              <el-menu-item v-for="term in item.children" :key="term.path" :index="term.path" v-if="term.meta.menuShow">
                <!-- <i :class="term.iconCls"></i> -->
                <span slot="title">{{ term.name }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else-if="item.leaf" :index="item.path" v-show="item.meta.menuShow" :key="index">
              <!-- <i :class="item.iconCls"></i> -->
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </template>
        </template>
      </template>
    </el-menu>
  </aside>
</template>
<script>
  export default {
    name: "leftNav",
    data() {
      return {
        collapsed: this.$store.state.collapsed
      };
    },
    methods: {
      // 左侧导航栏根据当前路径默认打开子菜单（如果当前是二级菜单，则父级子菜单默认打开）
      defaultLeftNavOpened() {
        let cur_path = this.$route.path; //获取当前路由
        let routers = this.$router.options.routes; // 获取路由对象

        let subMenuIndex = "",
          needOpenSubmenu = false;
        for (let i = 0; i < routers.length; i++) {
          let children = routers[i].children;
          if (children) {
            for (let j = 0; j < children.length; j++) {
              if (children[j].path === cur_path) {
                break;
              }
              // 如果该菜单下还有子菜单
              if (children[j].children && !children[j].leaf) {
                let grandChildren = children[j].children;
                for (let z = 0; z < grandChildren.length; z++) {
                  if (grandChildren[z].path === cur_path) {
                    subMenuIndex = j;
                    needOpenSubmenu = true;
                    break;
                  }
                }
              }
            }
          }
        }
        if (this.$refs["leftNavigation"]&&Object.keys(this.$refs["leftNavigation"].submenus).length&& needOpenSubmenu) {
          this.$refs["leftNavigation"].open(subMenuIndex); // 打开子菜单
        }
      },
    },
    mounted() {
      this.defaultLeftNavOpened();
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/nav/leftNav.vue